import { PATIENT_CONSULTATION_STATUS } from "~/common/constants/consultation";
import { PatientIntakeBundle } from "~/common/utils/consultations/intake/interfaces";
import {
  CompletedConsultationCard,
  IntakeSubmittedCard,
  ScreeningCompletedAndIntakeStartedCard,
} from "~/patients/components";
import { useGetCurrentPatient } from "~/patients/hooks";

interface ConsultationCardProps {
  title: string;
  intakeData?: PatientIntakeBundle;
  isAutoPromotePatient?: boolean;
}

export const AppointmentConsultationCard = ({
  title,
  intakeData,
  isAutoPromotePatient,
}: ConsultationCardProps) => {
  const { data: user } = useGetCurrentPatient();
  const { consultation } = { ...user };

  const patientFilledIntake =
    intakeData && intakeData.sections_completed === intakeData.total_sections;

  const renderAutoPromotePatientCard = () => {
    switch (consultation?.status) {
      case PATIENT_CONSULTATION_STATUS.screening_not_started:
      case PATIENT_CONSULTATION_STATUS.screening_started:
      case PATIENT_CONSULTATION_STATUS.intake_not_started:
      case PATIENT_CONSULTATION_STATUS.intake_started:
      case PATIENT_CONSULTATION_STATUS.screening_submitted:
        return patientFilledIntake ? (
          <IntakeSubmittedCard title={title} />
        ) : (
          <ScreeningCompletedAndIntakeStartedCard title={title} />
        );

      case PATIENT_CONSULTATION_STATUS.intake_submitted:
        return <IntakeSubmittedCard title={title} />;

      case PATIENT_CONSULTATION_STATUS.appointment_scheduled:
        return <CompletedConsultationCard title={title} />;

      case PATIENT_CONSULTATION_STATUS.completed:
        return <CompletedConsultationCard title={title} />;

      default:
        return null;
    }
  };

  const renderCard = () => {
    switch (consultation?.status) {
      case PATIENT_CONSULTATION_STATUS.intake_not_started:
      case PATIENT_CONSULTATION_STATUS.intake_started:
        return patientFilledIntake ? (
          <IntakeSubmittedCard title={title} />
        ) : (
          <ScreeningCompletedAndIntakeStartedCard title={title} />
        );

      case PATIENT_CONSULTATION_STATUS.intake_submitted:
        return <IntakeSubmittedCard title={title} />;

      case PATIENT_CONSULTATION_STATUS.appointment_scheduled:
        return <CompletedConsultationCard title={title} />;

      case PATIENT_CONSULTATION_STATUS.completed:
        return <CompletedConsultationCard title={title} />;

      default:
        return null;
    }
  };

  return (
    <>{isAutoPromotePatient ? renderAutoPromotePatientCard() : renderCard()}</>
  );
};
